import { makeStyles } from "@material-ui/core";

const styles = makeStyles(() => ({
  root: {},
  fields: {
    // we're controling the grid's row spacing
    // because HvGrid still doesn't support it to
    // be different from the column spacing.
    "$root &>div": {
      paddingTop: 5,
      paddingBottom: 0,
    },
  },
  dropdownTopSection: {
    maxWidth: 540,
    minHeight: 96,
    "& > div:first-child": {
      alignItems: "flex-end",
      justifyContent: "space-between",
      "& > *:last-child": {
        padding: 0,
      },
    },
  },
  nameInput: {
    minHeight: 86,
  },
  textareaInput: {
    // !important needed because of https://github.com/visualization-suite/hvs_web/commit/755c0bf101b78b9038c75bfa23598ad6cc32d894#diff-61c28cd2cfcfd2fca70d1e3b7fcf909dd0bb7c1b3fe1c3cdc94444221f49f017R208
    resize: "none !important" as "none",
    overflow: "scroll",
  },
}));

export default styles;
